
export default {
  computed: {
    loading () {
      return this.$store.state.loading.isLoading
    },
  },
  methods: {
    startLoading (delay = 400) {
      this.$store.dispatch('loading/start', delay)
    },
    stopLoading () {
      this.$store.commit('loading/stop')
    },
  },
}
